<template>
  <div
    class="basic_product_display_index"
    @mouseenter="module_isHover(true)"
    @mouseleave="module_isHover(false)"
  >
    <div class="tooptipPart module_edit_btn" v-if="isHover">
      <my_hover_btn
        :tips="$t('widgets_basic_article_classification_index_336')"
        btnIcon="el-icon-edit"
        @changeStyle="edit_module"
      ></my_hover_btn>
      <my_hover_btn
        :tips="$t('widgets_basic_article_classification_edit_330')"
        btnIcon="el-icon-magic-stick"
        @changeStyle="animation_set"
        v-if="$store.state.app.view_pattern === 'pc'"
      ></my_hover_btn>
    </div>
    <div class="basic_product_display">
      <my_title_index :title="widgets_infor.title"></my_title_index>

      <div class="cate_info" v-if="isSystem" v-show="isPc">
        <span class="cate_title condition-cate-title" v-text="(typeName ?typeName : getLang('全部视频'))"></span>        
      </div>

      <div class="module_wrap" :class="'module_wrap_' + listArr.module_style">
        <basic_addProduct
          v-if="add_Product_isShow"
          @closed="add_Product_close"
          @submit_sure="submit_sure"
        ></basic_addProduct>
        <!-- 搜索条件 -->
        <div v-if="isSystem && pc_infor.search_is_open === 'true'">
          <!-- <cur_condition :typeName="typeName" @delType="delType" @searchPro="searchPro"></cur_condition> -->
          <div class="jz_empty_tips" v-if="list.length == 0">
            <i class="jz_empty_tips__img"></i>
            <div class="jz_empty_tips__text">{{$t('widgets_basic_product_display_index_2787')}}</div>
          </div>
        </div>
        <div
          class="empty"
          v-if="
            list.length == 0 &&
            !isSystem &&
            $store.state.app.view_pattern === 'pc'
          "
        >
          <!-- 直接添加 -->
          <div v-if="listArr.type == 'custom'">
            <selection_prompt
              type="goodsList"
              :ids.sync="listArr.custom"
              @add_content="add_content"
            ></selection_prompt>
          </div>
          <!-- 筛选条件 -->
          <div v-if="listArr.type == 'systom'">
            <selection_prompt
              type="goodsList"
              action="class"
              @select_class="select_class"
            ></selection_prompt>
          </div>
        </div>
        <my_mb_empty_tips
          v-if="
            list.length <= 0 &&
            !isSystem &&
            $store.state.app.view_pattern === 'mb'
          "
          :tip="$t('widgets_basic_classification_edit_482')"
        ></my_mb_empty_tips>
        <div class="module_content" v-loading="loading" v-if="list.length > 0">
          <!-- 第一种模式 -->
          <template v-if="listArr.module_style == 0">
            <div class="product_list_0">
              <one_img
                v-for="(item, i) in list"
                :key="i"
                :item="item"
                :module="module"
                :hideBtn="hideBtn"
                @getProduct="getProduct"
                @delete_video="delete_video"
              ></one_img>
            </div>
          </template>
          <!-- 第二种轮播图模式 -->
          <template v-if="listArr.module_style == 1">
            <!-- pc模式 -->
            <template v-if="$store.state.app.view_pattern === 'pc'">
              <div class="product_list_1">
                <swiper
                  ref="mySwiper"
                  class="list_box"
                  :options="swiperOption"
                  v-if="$store.state.app.basic_pro_display_isRender"
                >
                  <swiper-slide v-for="(item, i) in list" :key="i">
                    <one_img
                      :item="item"
                      :module="module"
                      :hideBtn="hideBtn"
                      @getProduct="getProduct"
                      @delete_video="delete_video"
                      type="swiper"
                    ></one_img>
                  </swiper-slide>
                </swiper>

                <template v-if="$store.state.app.view_pattern === 'pc'">
                  <div class="arrow prev" @click="swiper_prev"></div>
                  <div class="arrow next" @click="swiper_next"></div>
                </template>
              </div>
            </template>

            <template v-else>
              <div class="list_box flex_box mb_swiper_list">
                <one_img
                  v-for="(item, i) in list"
                  :key="i"
                  :item="item"
                  :module="module"
                  :hideBtn="hideBtn"
                  @getProduct="getProduct"
                  @delete_video="delete_video"
                ></one_img>
              </div>
            </template>
          </template>
          <!-- 第三种左图右文 -->
          <template v-if="listArr.module_style == 2">
            <div class="product_list_2">
              <one_img
                v-for="(item, i) in list"
                :key="i"
                :item="item"
                :module="module"
                :hideBtn="hideBtn"
                @getProduct="getProduct"
                @delete_video="delete_video"
              ></one_img>
            </div>
          </template>
          <!-- 第四种只有文字 -->
          <template v-if="listArr.module_style == 3">
            <div class="product_list_3">
              <one_img
                v-for="(item, i) in list"
                :key="i"
                :item="item"
                :module="module"
                :hideBtn="hideBtn"
                @getProduct="getProduct"
                @delete_video="delete_video"
              ></one_img>
            </div>
          </template>
          <my_page_index
            v-if="
              pc_infor.page.radioValue &&
              list.length > 0 &&
              listArr.module_style !== 1
            "
            :page="pc_infor.page"
            :currentPage.sync="currentPage"
            :total="total"
            @change-page="changePage"
          ></my_page_index>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import selection_prompt from "@/components/selection_prompt";
import { getArticleListBy1,deleteArtical } from "@/api/app.js";
import one_img from "./components/one_img";
import cur_condition from "./components/cur_condition";
import {box_shadow_style_add, getBackgroundData, getSwiperSettingData, fontSet,getCommonStyle} from "@/base/widgets_data_compatible";

export default {
  name: "basic_video_display_index",
  components: {
    selection_prompt,
    one_img,
    cur_condition,
  },
  props: {
    module: {
      type: Object,
      default: null,
    },
    column: {
      type: Object,
      default: null,
    },
    row: {
      type: Object,
      default: null,
    },
    module_index: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    isPc() {
      return this.$store.state.app.view_pattern === "pc";
    },
    listArr() {
      return this.module.data.listArr;
    },
    pc_infor() {
      return this.module.data.pc_widgets_infor;
    },
    widgets_infor() {
      return this.module.data[
        this.$store.state.app.view_pattern + "_widgets_infor"
      ];
    },
    swiperOption() {
      const infor = this.module.data.pc_widgets_infor;
      const num = infor.col_num[infor.col_num.radio_val].value;
      console.log(33, num);
      return {
        myVm: this,
        loop: false,
        direction: "horizontal",
        slidesPerView: num,
        slidesPerGroup: num,
        observer: true,
        observeParents: true,
      };
    },
  },
  watch: {
    listArr: {
      handler: function (val) {
        this.page_reset();
        //this.templet.get_product(this);
        this.get_video();
      },
      deep: true,
    },
    "pc_infor.page": {
      handler: function (val) {
        this.page_reset();
        //this.templet.get_product(this);
        this.get_video();
      },
      deep: true,
    },
    "pc_infor.showNum": {
      deep: true,
      handler(val) {
        this.page_reset();
        //this.templet.get_product(this);
        this.get_video();
      },
    },
    "pc_infor.showAll": {
      deep: true,
      handler(val) {
        this.page_reset();
        //this.templet.get_product(this);
        this.get_video();
      },
    },
  },
  data() {
    return {
      isHover: false,
      add_Product_isShow: false,
      isReset: false,
      list: [],
      loading: false,
      currentPage: 1,
      total: 0,
      proTypeId: this.$route.query.id !== undefined ? this.$route.query.id : "",
      typeName:
        this.$route.query.name !== undefined ? this.$route.query.name : "",
      keyword: "",
      isSystem: this.module.data.isSystem === "true" ? true : false,
      hideBtn: false,
    };
  },
  created() {
    this.templet.checkShowValue(this.module.data.pc_widgets_infor);
    //搜索是否开启 兼容处理
    if (typeof this.pc_infor.search_is_open == "undefined") {
      this.$set(this.pc_infor, "search_is_open", "true");
    }
  },
  mounted() {
    this.fixField()
    this.get_video();
    if (this.module.data.isSystem === "true") {
      this.module.data.listArr.type = "all";
    }
    // 兼容处理
    if (this.module.data.listArr.sortBy === "sort") {
      this.module.data.listArr.sortBy = "default";
    }
  },
  methods: {
    /* 删除分类*/
    delType(val) {
      this.proTypeId = "";
      this.searchPro(val);
    },
    /* 模糊搜索*/
    searchPro(val) {
      this.keyword = val;
      this.page_reset();
      this.templet.get_product(this);
    },
    getProduct() {
      this.page_reset();
      this.get_video();
    },
    /* 是否显示tooptipPart*/
    module_isHover(val) {
      this.isHover = val;
    },
    /* 编辑模块*/
    edit_module() {
      this.templet.changeStyle(this.module, "style");
    },
    /* 动画设置*/
    animation_set() {
      this.templet.changeStyle(this.module, "animation");
    },
    /* 删除模块*/
    del_module() {
      this.templet.del_module(
        this.column.widgets_id,
        this.module_index,
        this.module.data.anchor_id
      );
    },
    /* 选择产品*/
    add_content() {
      this.add_Product_isShow = true;
    },
    /* 关闭新增产品窗口*/
    add_Product_close() {
      this.add_Product_isShow = false;
    },
    /* 新增产品，确定按钮*/
    submit_sure(val) {
      // this.add_Product_close();
      this.listArr.custom.push(val);
    },
    /* 上一个*/
    swiper_prev() {
      this.$refs.mySwiper.swiper.slidePrev();
    },
    /* 下一个*/
    swiper_next() {
      this.$refs.mySwiper.swiper.slideNext();
    },
    //选择分类
    select_class() {
      this.listArr.type = "systom";
      this.templet.changeStyle(this.module);
    },
    /* 重置分页*/
    page_reset() {
      //this.list = [];
      this.isReset = true;
      this.currentPage = 1;
      this.total = 0;
    },
    changePage(val) {
      this.currentPage = val;
      this.get_video();
      //this.templet.get_product(this);
    },
    /* 获取视频列表 */
    get_video(that_data, type = "index") {
      this.loading = true;
      const query = {
        type: 11,
        sort: this.listArr.sortBy,
        order: this.listArr.sort,
        rows: 10,
        page: 1,
        category_id: this.isSystem ? this.$route.query.typeId || "" : "",
        is_up: "true",
      };

      if (this.module && this.module.data) {
        let page = this.module.data.pc_widgets_infor.page;

        if (this.listArr.module_style !== 1 && page.radioValue) {
          //需要分页
          query.rows = page.pageSize;
          query.page = this.currentPage;
        } else {
          query.rows = 999999;
          query.page = 1;
        }
      }
      getArticleListBy1(query)
        .then((e) => {
          if (
            e.code == 200 &&
            e.data &&
            e.data.rows &&
            e.data.rows instanceof Array
          ) {
            this.total = e.data.total;
            //list是组件index.vue中渲染试图的变量
            //不同的分页，渲染方式不同
            if (type == "index") {
              const page = this.module.data.pc_widgets_infor.page;
              if (page.radioValue && page.pageStyle == 2) {
                //展开更多，数据插入，不是数据重写
                if (this.isReset) {
                  this.isReset = false;
                  this.list = [];
                }
                e.data.rows.map((item) => {
                  this.list.push(item);
                });
              } else {
                this.list = this.pro_data_filter(e.data.rows);
              }
              // console.log(that_data.pc_infor.showAll)
              if (!this.pc_infor.page.radioValue) {
                if (!this.pc_infor.showAll) {
                  this.list = this.list.slice(0, this.pc_infor.showNum);
                } else {
                  this.list = this.list.slice(0, 200);
                }
              }
            } else {
              this.se_list = this.pro_data_filter(e.data.rows);
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    pro_data_filter(list) {
      return list.map((item) => {
        item.name = item.title;
        return item;
      });
    },
    delete_video(id){
      deleteArtical({
        ids: id,
      }).then((e)=>{
        this.get_video();
        
      })
    },
    fixField() {
      if (!this.pc_infor.background) {
        this.$set(this.pc_infor, "background", getBackgroundData().background);
      }
      // 4.6.7 组合阴影
      if (typeof this.pc_infor.boxShadow == "undefined") {
        this.$set(this.pc_infor, "boxShadow", box_shadow_style_add().boxShadow);
      }
      if(typeof this.pc_infor.product_name_font == "undefined"){
        this.$set(this.pc_infor, 'product_name_font', fontSet())
      }
      if(typeof this.pc_infor.textAlign == "undefined"){
        this.$set(this.pc_infor, 'textAlign', 'left')
      }
      if(typeof this.pc_infor.showSummary == "undefined"){
        this.$set(this.pc_infor, 'showSummary', 'true')
      }
      // 圆角
      if (typeof this.pc_infor.borderRadius == "undefined") {
        this.$set(this.pc_infor, "borderRadius", getCommonStyle().borderRadius);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.basic_product_display_index {
  position: relative;
  box-sizing: border-box;
  min-height: 30px;
  min-width: 30px;
  height: 100%;
  .tooptipPart {
    right: 0;
    top: 0;
    display: block;
    z-index: 999;
  }
}
.flex_box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.basic_product_display {
  .textEdit {
    display: block;
    width: 100%;
    cursor: text;
    min-width: 10px;
    overflow: hidden;
    pointer-events: none;
  }
  .cate_info{
    padding: 10px 10px 0px 10px;
    font-size: 14px;
    .cate_title{
      font-weight: bold;
    }
  }
}
.pc_pattern .module_wrap {
  padding-top: 20px;
}
.mb_pattern {
  .module_wrap_0,
  .module_wrap_1,
  .module_wrap_2 {
    padding-top: 28px;
  }
  .module_wrap_1 {
    padding-top: 18px;
  }
}
.module_wrap {
  .module_content {
    position: relative;
    font-size: 14px;
    .product_list_0 {
      display: flex;
      flex-wrap: wrap;
      align-items: stretch;
      /deep/ .list_one {
        height: auto !important;
      }
    }
    .product_list_2 {
      /deep/ .list_one {
        width: calc(100% - 20px);
        padding: 20px;
        margin: 20px 10px;
        overflow: visible;
        &:not(:last-child):after {
          content: "";
          width: 100%;
          height: 0;
          border-bottom: 1px dashed #f0f0f0;
          display: block;
          position: absolute;
          bottom: -20px;
          left: 0;
        }
        .list_content_frame {
          float: left;
          margin-left: 20px;
          width: calc(75% - 20px);
          text-align: left;
        }
      }
      /deep/ .list_img_frame {
        width: 25%;
        padding-bottom: 25%;
        float: left;
      }
      /deep/ .list_one_wrap {
        display: block;
        height: 100%;
        color: #333;
        padding: 0;
        overflow: visible;
      }
    }
    .product_list_3 {
      /deep/ .list_one {
        text-align: left;
        border: 1px solid #f0f0f0;
        border-radius: 2px;
        transition: none;
        padding: 0;
      }
      /deep/ .list_one_wrap {
        position: relative;
        transition: 0.5s;
        .product_name_wrap {
          margin-bottom: 0 !important;
          margin-top: 0 !important;
          .product_name {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            display: inline-block;
            max-width: 100%;
          }
        }
      }
      /deep/ .list_img_frame {
        display: none;
      }
    }
    .product_list_1 {
      padding: 0 60px;
      position: relative;
      .list_box {
        .swiper-wrapper {
          .swiper-slide {
            height: auto;
            .list_one {
              height: 100%;
              padding: 10px;
              margin: 0 !important;
              width: 100% !important;
            }
          }
        }
      }
      .arrow {
        cursor: pointer;
        display: block;
        width: 40px;
        height: 40px;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        position: absolute;
        z-index: 99;
        top: 50%;
        transform: translateY(-50%);
        background: rgba(0, 0, 0, 0.2);
        transition: background 0.15s;
        outline: 0;
      }
      .arrow:before {
        content: "";
        position: absolute;
        display: block;
        width: 10px;
        height: 18px;
        background: url("/static/image/backimg1.png") -23px -268px;
        top: 50%;
        left: 50%;
        transform: translate(-50%) translateY(-50%);
      }
      .prev {
        left: 10px;
      }
      .next {
        right: 10px;
      }
      .next:before {
        background-position-x: -53px;
        left: 54%;
      }
    }
  }
}
.mb_pattern {
  .basic_product_display_index {
    .product_list_0,
    .product_list_1,
    .product_list_2,
    .mb_swiper_list {
      padding: 0 1.8%;
      width: auto;
    }
  }
}
.mb_pattern {
  .basic_product_display_index {
    /deep/ .list_content_frame {
      text-align: left;
      margin: 6px;
      .product_name_wrap {
        margin-top: 0 !important;
        margin-bottom: 5px !important;
        .product_name {
          font-size: 14px !important;
        }
      }
    }
    .mb_swiper_list {
      width: 100%;
      display: block;
      overflow-x: auto;
      white-space: nowrap;
      /deep/ .list_one {
        width: 45%;
        text-align: left;
        padding: 10px;
        margin: 0 !important;
        .list_one_wrap {
          padding: 0;
        }
      }
    }
    .mb_swiper_list::-webkit-scrollbar {
      height: 0px;
    }
    .product_list_0 {
      /deep/ .list_one_wrap {
        padding: 0;
      }
    }
    .product_list_2 {
      /deep/ .list_one {
        padding: 0;
        margin: 10px;
        .list_img_frame {
          width: 33.8%;
          padding-bottom: 33.8%;
          float: left;
        }
        .product_name_wrap {
          margin: 6px !important;
        }
        .list_content_frame {
          width: 66.2%;
          display: inline-block;
          float: none;
          margin: 0;
          box-sizing: border-box;
          padding-left: 12px;
        }
      }
    }
    .product_list_3 {
      margin-top: 0;
      /deep/ .list_one {
        text-align: left;
        width: 100%;
        border: none;
        margin: 0;
        padding: 15px;
        border-bottom: 1px solid #f1f1f1;
        .list_one_wrap {
          padding: 0;
        }
        .list_content_frame {
          margin: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_video_display/index.vue